import React from "react";
import { LoginForm } from "../components";

const LoginContainer = () => {
  return (
    <div className="col-xs-6 col-xs-push-3">
      <LoginForm />
    </div>
  );
};

export default LoginContainer;
